<table mat-table [dataSource]="investorApprovals">
  <ng-container matColumnDef="investor">
    <th mat-header-cell *matHeaderCellDef="">Investor</th>
    <td mat-cell *matCellDef="let item">
      <contact-link [subject]="item.investor"></contact-link>
    </td>
  </ng-container>
  <ng-container matColumnDef="approval_status">
    <th mat-header-cell *matHeaderCellDef>Approval Status</th>
    <td mat-cell *matCellDef="let item" [class]="{readOnly}">
      @if (readOnly || !(permission | permission: '_edit')) {
        <span
        [class]="{
          approval: item.approval_status?.is_approval === true,
          denial: item.approval_status?.is_approval === false,
          readOnlyStatus: true
        }">
          {{ item.approval_status ? item.approval_status.status : "\u2014" }}
        </span>
      }
      @if (!readOnly && (permission | permission: '_edit')) {
        <mat-form-field
        [color]="
          item.approval_status?.is_approval === true
            ? 'accent'
            : item.approval_status?.is_approval === false
            ? 'warn'
            : 'primary'
        ">
          <mat-label>Approval Status</mat-label>
          <mat-select
          [class]="{
            approval: item.approval_status?.is_approval === true,
            denial: item.approval_status?.is_approval === false
          }"
            [(ngModel)]="item.approval_status">
            <mat-option>&mdash;</mat-option>
            @for (status of approvalStatuses; track status) {
              <mat-option [value]="status">
                {{ status.status }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="owned_percent">
    <th mat-header-cell *matHeaderCellDef>Owned %</th>
    <td mat-cell *matCellDef="let item">
      {{
      item.owned_percent ? (item.owned_percent | percent: "1.2-2") : "\u2014"
      }}
    </td>
  </ng-container>
  <ng-container matColumnDef="status_date">
    <th mat-header-cell *matHeaderCellDef>Status Date</th>
    <td mat-cell *matCellDef="let item">
      @if (!readOnly && (permission | permission: '_edit')) {
        <mat-form-field>
          <input
            matInput
            [(ngModel)]="item.status_date"
            [matDatepicker]="statusDate" />
          <mat-datepicker-toggle
            [for]="statusDate"
          matIconSuffix></mat-datepicker-toggle>
          <mat-datepicker #statusDate></mat-datepicker>
        </mat-form-field>
      }
      @if (readOnly || !(permission | permission: '_edit')) {
        <span>
          {{ item.status_date | date: "MM/dd/yyyy" }}
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="comments">
    <th mat-header-cell *matHeaderCellDef>Comments</th>
    <td mat-cell *matCellDef="let item">
      @if (!readOnly && (permission | permission: '_edit')) {
        <mat-form-field>
          <textarea
            matInput
            [(ngModel)]="item.comments"
            cdkTextareaAutosize
          style="resize: none"></textarea>
        </mat-form-field>
      }
      @if (readOnly || !(permission | permission: '_edit')) {
        <span>
          {{ item.comments }}
        </span>
      }
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns"></tr>
</table>
